import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
  selector: '[appNotOnlyNumbers]',
  providers: [{ provide: NG_VALIDATORS, useExisting: NotOnlyNumbersDirective, multi: true }],
  standalone: false
})
export class NotOnlyNumbersDirective implements Validator {
  @Input('appNotOnlyNumbers') isActive = true;

  static validator(control: AbstractControl, isActive: boolean = true): ValidationErrors | null {
    return (typeof isActive === 'boolean' && !isActive) || !control.value || (typeof control.value === 'string' && !NotOnlyNumbersDirective.isOnlyNumbers(control.value))
      ? null
      : { appNotOnlyNumbers: true };
  }

  static isOnlyNumbers(text: string) {
    return /^\d+$/.test(text.trim());
  }

  constructor() {}

  validate(control: AbstractControl) {
    return NotOnlyNumbersDirective.validator(control, this.isActive);
  }
}
